import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

import { MostRecentChangesService } from 'src/app/_services/most-recent-changes.service';

@Component({
  selector: 'app-active-issues',
  templateUrl: './active-issues.component.html',
  styleUrls: ['./active-issues.component.scss'],
  providers: [DialogService],
})
export class ActiveIssuesComponent implements OnInit {
  recentChanges: any[] = [];
  recentChangesLoading = true;

  constructor(private mostRecentChangesService: MostRecentChangesService) {}

  ngOnInit(): void {
    this.mostRecentChangesService.getMostRecentChangesActiveIssues().subscribe({
      next: (res: any[]) => {
        this.recentChanges = (res ?? []).slice(0, 8);
        this.recentChangesLoading = false;
      },
      error: () => {
        this.recentChanges = [];
        this.recentChangesLoading = false;
      },
    });
  }
}
